<div [formGroup]="additionalInfoForm">
  <div>
    <!--Additional Information Header-->
    <div id="sd_additional_info" class="py-2">{{ 'AdditionalInfo.additionalInformation' | translate }}</div>
    <!--Line Manager-->
    <div class="row mt-3" *ngIf="showLineManager">
      <div class="col-md-2 col-lg-2 col-xl-2">
        <label class="ml-2" for="lineManager" id="sd_line_manager">
          {{ 'AdditionalInfo.lineManagerLabel' | translate }}
        </label>
      </div>
      <div class="col-md-3 col-lg-3 col-xl-3">
        <input class="form-control" id="sd_line_manager_name" type="text" name="lineManager" value="{{ lineManager }}" disabled>
      </div>
    </div>

    <!--Location-->
    <div class="row mt-3">
      <div class="col-md-2 col-lg-2 col-xl-2">
        <label  class="ml-2" for="location" id="sd_location">
          {{ 'AdditionalInfo.locationLabel' | translate }}
        </label>
      </div>
      <div class="col-md-3 col-lg-3 col-xl-3">
        <input class="form-control" id="sd_location_name" type="text" maxlength="128" name="location" value="{{ location }}" formControlName="location">
      </div>
    </div>
  </div>
</div>
